export const OS1_DevPortal_URL = "https://api.os1.dev";
export const SYSTEM_APP_ID = "systemApp:cfb47586-d92e-4731-8321-c6dc817aa8f2";
